import { t } from 'i18next';
import { 
  ISyllabus, 
  ISyllabusData, 
  ISyllabusParams, 
  ITableRes, 
  ISyllabusItem,
} from 'types'
import { baseApi } from './baseApi'

export const syllabusAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    //Syllabus
    GET_syllabuses: builder.query<ITableRes<ISyllabusItem>, ISyllabusParams>({
      query: (params) => ({
        url: '/syllabuses/',
        params,
      }),
      providesTags: ['syllabuses'],
    }),
    GET_syllabusById: builder.query<ISyllabus, string>({
      query: (id) => {
        return {
          url: `/syllabuses/${id}/`,
        }
      },
      providesTags: ['syllabus'],
    }),
    POST_syllabus: builder.mutation<ISyllabus, ISyllabusData>({
      query: (body) => ({
        url: `/syllabuses/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['syllabuses', 'syllabus'],
    }),
    PUT_syllabus: builder.mutation<ISyllabus, { id: string; body: ISyllabusData }>({
      query: ({ id, body }) => ({
        url: `/syllabuses/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['syllabuses', 'syllabus'],
    }),
    DELETE_syllabus: builder.mutation<ISyllabus, string>({
      query: (id) => ({
        url: `/syllabuses/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['syllabuses'],
    }),

    /*
    //Course Setup Main
    GET_courseSetupMain: builder.query<ITableRes<ICourseComponent>, void>({
      query: () => ({
        url: '/course-setup-main/',
      }),
      providesTags: ['course-setup-main'],
    }),

    POST_courseSetupMain: builder.mutation<ICourseSetupMainData, ICourseSetupMainData>({
      query: (body) => ({
        url: `/course-setup-main/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['course-setup-main'],
    }),
    */
  }),
})

export const { 
  useGET_syllabusesQuery, 
  useGET_syllabusByIdQuery, 
  usePOST_syllabusMutation, 
  usePUT_syllabusMutation, 
  useDELETE_syllabusMutation
  /*
  useGET_courseSelectQuery,
  useGET_courseSetupMainQuery, 
  usePOST_courseSetupMainMutation, 
  */
} = syllabusAPI
